export default __webpack_public_path__ + "static/media/office_3.f935ca21.jpeg";